import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';
import messages from 'src/pages/ProjectDetailsPage/messages';

const rejectShift = async ({
  jobUuid,
  applicationUuid,
  reason,
  type,
}: {
  jobUuid: string;
  applicationUuid: string;
  reason: string;
  type: 'reject' | 'cancel';
}) => {
  const payload = { job_application: { reason_code: reason } };
  const res = await putRequest(
    API.PUT.rejectShift(jobUuid, applicationUuid, type),
    payload,
  );
  return res.data;
};

export const useUpdateRejectShift = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: rejectShift,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CALENDAR_JOBS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.DISPO_TIME_WINDOWS],
      });
      handleSuccess(formatMessage(messages.applicationRejected));
    },
    onError: handleError,
  });
};
